import env from 'src/config/env'

export const APP_NAME ='app';

export const PATHS = {
  LOADING:'loading',

  HOME:'home',

  SCENE:'game',

  WIN:'win',
  LOSE:'lose',
  
}

export const MODAL_STATES = {
  NONE:'NONE',
  MENU:'MENU'
}

export const GETTERS = {
}

export const ACTIONS = {
  getVersion:'getVersion'
}

export const MUTATIONS = {
  
  setVersion:'setVersion',
  setLoadProgress:'setLoadProgress',
  setLoadStep:'setLoadStep',
  setLoadComplete:'setLoadComplete',

  setAppState:'setAppState',
  setModalState:'setModalState',
  setRoute:'setRoute',
  setRouteAfterLoad:'setRouteAfterLoad',
  
}

export const STATES = {
  debug: 'debug',
  vconsole: 'vconsole',
  staging: 'staging',

  version:'version',
  loading:'loading',
  route:'route',

  app_state:'app_state',
  prev_app_state:'prev_app_state',

  modal_state:'modal_state',
  
}
